



















import Vue from 'vue';

export default Vue.extend({
    name: 'JoinWrapper',
    props: {
        header: {
            type: String,
            required: true,
        },
        subHeader: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
    },
});
